module.exports = __webpack_public_path__ + "static/media/apartment1.15cabd69.jpg";